import { ButtonGroup, IconButton } from '@chakra-ui/react';
import { Tooltip } from '@/components/ui/tooltip';
import { FiHome, FiBriefcase, FiLayers } from 'react-icons/fi'
import type { OverlayMode } from '../../types/workplaceOverlay'
import { useIsUnionTier } from '../../hooks/useIsUnionTier'

interface OverlayModeToggleProps {
  mode: OverlayMode
  onChange: (mode: OverlayMode) => void
  disabled?: boolean
}

const modes: { value: OverlayMode; label: string; icon: React.ReactElement }[] = [
  { value: 'home', label: 'Home addresses', icon: <FiHome /> },
  { value: 'work', label: 'Workplaces', icon: <FiBriefcase /> },
  { value: 'hybrid', label: 'Hybrid (work + home)', icon: <FiLayers /> },
]

export function OverlayModeToggle({ mode, onChange, disabled }: OverlayModeToggleProps) {
  if (!useIsUnionTier()) return null
  return (
    <ButtonGroup size="sm" attached variant="outline">
      {modes.map(m => (
        <Tooltip key={m.value} content={m.label} showArrow positioning={{
          placement: "top"
        }}>
          <IconButton
            aria-label={m.label}
            disabled={disabled}
            colorPalette={mode === m.value ? 'blue' : 'gray'}
            variant={mode === m.value ? 'solid' : 'outline'}
            onClick={() => onChange(m.value)}>{m.icon}</IconButton>
        </Tooltip>
      ))}
    </ButtonGroup>
  );
}
